import { DOCS_URL } from "../../../config/constants.js";
import { ETitleFontSizes } from "../../../config/enums.js";
import FAQ from "./FAQ.svelte";

export default {
    component: FAQ,
    name: "FAQ",
    description: "Frequently Asked Questions section with expandable details/summary elements",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-faq--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/help-circle.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fb1aa1a73608c44bf8ed768a74fe6a95b",
    inputs: [
        {
            friendlyName: "Show Heading",
            name: "showHeading",
            type: "boolean",
            defaultValue: true,
            helperText: "Toggle visibility of the section heading",
        },
        {
            friendlyName: "Heading Text",
            name: "heading",
            type: "string",
            defaultValue: "Frequently Asked Questions",
            showIf: `options.get('showHeading') === true`,
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('showHeading') === true`,
        },
        {
            friendlyName: "Heading Size (Visual)",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H4,
            helperText: "Select the visual styling/font size for the heading",
            showIf: `options.get('showHeading') === true`,
        },
        {
            friendlyName: "Allow Multiple Open",
            name: "allowMultipleOpen",
            type: "boolean",
            defaultValue: true,
            helperText:
                "When enabled, multiple FAQ items can be open at once. When disabled, opening one FAQ closes the others (accordion behaviour).",
        },
        {
            friendlyName: "FAQ Items",
            name: "items",
            type: "list",
            required: true,
            defaultValue: [
                {
                    question: "Question",
                    answer: "<p>Answer</p>",
                },
            ],
            subFields: [
                {
                    friendlyName: "Question",
                    name: "question",
                    type: "longText",
                    required: true,
                },
                {
                    friendlyName: "Answer",
                    name: "answer",
                    type: "richText",
                    required: true,
                    helperText:
                        "Supports HTML formatting including bold, italic, links, and lists. Use formatting sparingly for better readability.",
                },
            ],
        },
    ],
};
